import {
  PP,
  HP,
  LANDING_PAGE_SOURCE,
  TP,
  ADP,
  OTHER,
  SRP,
} from '../sourceTypes';
import { LandingPageTypes } from '../../helpers/domain/landingPages';
import { generateEventSourceByPageType } from './analyticsSourceHelper';

export const getAnalyticsSource = (urlPath: string) => {
  urlPath = decodeURI(urlPath);

  if (urlPath === '/') {
    return HP.PAGE;
  }
  if (urlPath === '/คอนโด/') {
    return LANDING_PAGE_SOURCE.CONDO;
  }
  if (urlPath === '/บ้าน/') {
    return LANDING_PAGE_SOURCE.HOME;
  }
  if (urlPath === '/ทาวน์โฮม/') {
    return LANDING_PAGE_SOURCE.TOWN_HOME;
  }
  if (urlPath === '/ตากอากาศ/') {
    return LANDING_PAGE_SOURCE.VACATION;
  }
  if (urlPath === '/โฮมออฟฟิศ/') {
    return LANDING_PAGE_SOURCE.HOME_OFFICE;
  }
  if (urlPath === '/มิกส์ยูส/') {
    return LANDING_PAGE_SOURCE.MIX_USED;
  }
  if (urlPath === '/อาคารพาณิชย์/') {
    return LANDING_PAGE_SOURCE.COMMERCIAL;
  }

  if (urlPath === '/รีวิวโครงการ/') {
    return generateEventSourceByPageType(LandingPageTypes.ProjectResearchPage);
  }
  if (urlPath === '/รีวิวโครงการ/พรีวิวโครงการใหม่/') {
    return generateEventSourceByPageType(LandingPageTypes.PreviewPage);
  }
  if (urlPath === '/รีวิวโครงการ/รีวิว/') {
    return generateEventSourceByPageType(LandingPageTypes.ReviewPage);
  }
  if (urlPath === '/รีวิวโครงการ/point-of-view/') {
    return generateEventSourceByPageType(LandingPageTypes.PointOfViewPage);
  }
  if (urlPath === '/รีวิวทำเล/') {
    return generateEventSourceByPageType(LandingPageTypes.LocationInsightPage);
  }

  if (urlPath === '/รีวิวทำเล/ย่าน/') {
    return generateEventSourceByPageType(LandingPageTypes.ZonesPage);
  }

  if (urlPath === '/รีวิวทำเล/รถไฟฟ้า/') {
    return generateEventSourceByPageType(LandingPageTypes.TrainlinesPage);
  }

  if (urlPath === '/ข่าว/') {
    return generateEventSourceByPageType(LandingPageTypes.NewsPage);
  }
  if (urlPath === '/ข่าว/ข่าวอสังหา/') {
    return generateEventSourceByPageType(LandingPageTypes.PropertyNewsPage);
  }
  if (urlPath === '/ข่าว/ข่าวทั่วไป/') {
    return generateEventSourceByPageType(LandingPageTypes.GeneralNewsPage);
  }
  if (urlPath === '/คู่มือซื้อขาย/') {
    return generateEventSourceByPageType(LandingPageTypes.GuidesPage);
  }
  if (urlPath === '/คู่มือซื้อขาย/ซื้อ-ขายอสังหา/') {
    return generateEventSourceByPageType(LandingPageTypes.BuyAndSellPage);
  }
  if (urlPath === '/คู่มือซื้อขาย/สินเชื่อ/') {
    return generateEventSourceByPageType(LandingPageTypes.FinancePage);
  }
  if (urlPath === '/คู่มือซื้อขาย/ลงทุนอสังหา/') {
    return generateEventSourceByPageType(LandingPageTypes.InvestmentPage);
  }

  if (urlPath === '/ไอเดียตกแต่ง/') {
    return generateEventSourceByPageType(LandingPageTypes.DecorsPage);
  }

  if (urlPath === '/ไอเดียตกแต่ง/ออกแบบ-ตกแต่ง/') {
    return generateEventSourceByPageType(
      LandingPageTypes.InteriorInspirationPage,
    );
  }
  if (urlPath === '/ไอเดียตกแต่ง/วัสดุและการต่อเติม/') {
    return generateEventSourceByPageType(LandingPageTypes.RenovationPage);
  }
  if (urlPath === '/ไอเดียตกแต่ง/ดูแล-ซ่อมแซม/') {
    return generateEventSourceByPageType(LandingPageTypes.MaintenancePage);
  }
  if (urlPath === '/รีวิวโครงการ/รีวิว/คอนโด/') {
    return generateEventSourceByPageType(LandingPageTypes.ReviewCondoPage);
  }
  if (urlPath === '/รีวิวโครงการ/พรีวิวโครงการใหม่/คอนโด/') {
    return generateEventSourceByPageType(LandingPageTypes.PreviewCondoPage);
  }

  if (urlPath === '/รีวิวโครงการ/รีวิว/บ้าน/') {
    return generateEventSourceByPageType(LandingPageTypes.ReviewHousePage);
  }

  if (urlPath === '/รีวิวโครงการ/พรีวิวโครงการใหม่/บ้าน/') {
    return generateEventSourceByPageType(LandingPageTypes.PreviewHousePage);
  }

  if (urlPath === '/รีวิวโครงการ/รีวิว/ทาวน์โฮม/') {
    return generateEventSourceByPageType(LandingPageTypes.ReviewTownhomePage);
  }
  if (urlPath === '/รีวิวโครงการ/พรีวิวโครงการใหม่/ทาวน์โฮม/') {
    return generateEventSourceByPageType(LandingPageTypes.PreviewTownhomePage);
  }

  const urlParts = urlPath.split('/');
  if (urlParts[1] === 'list') {
    return SRP.PAGE;
  }
  if (urlParts[2] === 'project') {
    return PP.PAGE;
  }
  if (urlParts[1] === 'tag') {
    return TP.PAGE;
  }
  if (urlParts[1] === 'author') {
    return OTHER.PAGE;
  }
  if (urlParts[1] === 'category') {
    return OTHER.PAGE;
  }

  return ADP.PAGE;
};
